import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Col } from "reactstrap";
import { DatePicker } from "jalali-react-datepicker";
import Cookies from "js-cookie";
import TimeKeeper from "react-timekeeper";
import { setNewSchedule, scheduleEditApi, limitList } from "../../api";
import { scheduleEdit } from "../../redux";
import { Alert } from "../";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const ScheduleCompp = (props) => {
  const { t } = useTranslation();
  var daysFA = [
    t("شنبه"),
    t("یکشنبه"),
    t("دوشنبه"),
    t("سه شنبه"),
    t("چهارشنبه"),
    t("پنجشنبه"),
    t("جمعه"),
  ];
  const { zone, command, toggleSchedule, scheduleData } = props;
  const [startDate, setStartDate] = useState(new Date());
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [today, setToday] = useState(null);
  const [once, setOnce] = useState("0");
  const [scheduleEnDate, setScheduleEnDate] = useState(
    scheduleData?.start_date
      ?.replace(/[٠-٩]/g, (d) => t("٠١٢٣٤٥٦٧٨٩").indexOf(d))
      .replace(/[۰-۹]/g, (d) => t("۰۱۲۳۴۵۶۷۸۹").indexOf(d))
  );
  let days2 = scheduleData?.days.split(",");

  const [dayIndex, setDayIndex] = useState([
    {
      index: 0,
      isActive: scheduleData && days2.includes("1") ? true : false,
    },
    {
      index: 1,
      isActive: scheduleData && days2.includes("2") ? true : false,
    },
    {
      index: 2,
      isActive: scheduleData && days2.includes("3") ? true : false,
    },
    {
      index: 3,
      isActive: scheduleData && days2.includes("4") ? true : false,
    },
    {
      index: 4,
      isActive: scheduleData && days2.includes("5") ? true : false,
    },
    {
      index: 5,
      isActive: scheduleData && days2.includes("6") ? true : false,
    },
    {
      index: 6,
      isActive: scheduleData && days2.includes("7") ? true : false,
    },
    {
      index: 7,
      isActive: scheduleData && days2.indexOf("8") ? true : false,
    },
  ]);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [time, setTime] = useState("12:30");
  const [date, setDate] = useState();
  const [dayNumber, setDayNumber] = useState(scheduleData ? days2 : []);

  function submitExample({ value }) {
    const date = value._d
      .toLocaleDateString("fa-IR")
      .replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
    setDate(date);
  }

  const dayClicked = (i) => {
    if (!dayIndex[i].isActive) {
      setDayIndex(
        dayIndex.map((item) =>
          item.index === i
            ? {
                ...item,
                isActive: true,
              }
            : item
        )
      );
      setDayNumber((prev) => [...prev, i + 1]);
    } else {
      setDayIndex(
        dayIndex.map((item) =>
          item.index === i
            ? {
                ...item,
                isActive: false,
              }
            : item
        )
      );
      setDayNumber(dayNumber.filter((item) => item !== i + 1));
    }
  };

  const setScheduleCommand = () => {
    const data = new FormData();
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    data.append("time", time !== undefined ? time : scheduleData.time);
    data.append("once", once);
    if (date !== undefined) {
      data.append("start_date", date);
    }
    if (once === "0") {
      data.append(
        "days",
        dayNumber.length !== 0 || dayNumber !== undefined
          ? dayNumber
          : scheduleData.days
      );
    }
    if (scheduleData !== undefined) {
      data.append("command", scheduleData.command);
      data.append("schedule", scheduleData.id);
      scheduleEditApi(data, token)
        .then(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("زمانبندی با موفقیت ویرایش شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
            toggleSchedule();
          }, 2000);
          dispatch(
            scheduleEdit({
              id: scheduleData.id,
              time: time !== undefined ? time : scheduleData.time,
              start_date: date,
              days:
                dayNumber.length !== 0
                  ? dayNumber.toString()
                  : scheduleData.days,
              once: once,
            })
          );
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 2000);
          }
        });
    } else {
      data.append("command", command.command);
      setNewSchedule(data, token)
        .then(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("زمانبندی با موفقیت ثبت شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
            toggleSchedule();
          }, 2000);
        })
        .catch((err) => {
          if (err.response.status === 400) {
            limitList(token).then((result) => {
              if (result.data.data.schedule_limit) {
                setShowAlert((prevState) => ({
                  ...prevState,
                  show: true,
                  message: t("موارد بالا را تکمیل نمایید."),
                  type: "Error",
                }));
                setTimeout(() => {
                  setShowAlert((prevState) => ({
                    ...prevState,
                    show: false,
                  }));
                }, 3000);
              } else {
                setShowAlert((prevState) => ({
                  ...prevState,
                  show: true,
                  message: t(" سقف مجاز برای زمانبندی به اتمام رسیده است."),
                  type: "Error",
                }));
                setTimeout(() => {
                  setShowAlert((prevState) => ({
                    ...prevState,
                    show: false,
                  }));
                }, 3000);
              }
            });
          }

          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 2000);
          }
        });
    }
  };

  useEffect(() => {
    let d = new Date();
    let dayName = days[d.getDay()];
    setToday(dayName);
  }, []);

  const onceChanged = (e) => {
    if (e.target.checked) {
      setOnce("1");
    } else {
      setOnce("0");
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center weatherStatus">
        <i className="circleToping icon-clock text-center"></i>
        <div className="text-center mr-4">
          <p className="m-0"> {t("زمانبندی")}</p>
          {!scheduleData ? (
            <small className="text-muted-left">
              {`${command.command == "11" ? t("خاموش") : t("روشن")}`}
            </small>
          ) : (
            <small className="text-muted-left">{`${
              scheduleData.command == "11" ? t("خاموش") : t("روشن")
            }`}</small>
          )}
        </div>
      </div>
      <div style={{ minHeight: "65vh" }}>
        <div className="d-flex justify-content-center position-relative">
          <TimeKeeper
            hour24Mode={true}
            onChange={(data) => setTime(data.formatted24)}
            time={scheduleData ? scheduleData.time : null}
          />
        </div>
        <div>
          <div className="w-100 text-right d-flex align-items-center ">
            <p className="fn12 mb-0 mx-2">{t(" فقط یکبار ")}</p>
            <label className="switch">
              <input
                type="checkbox"
                id="myCheck"
                defaultChecked={
                  scheduleData ? scheduleData.once : once === "1" ? true : false
                }
                onChange={onceChanged}
              />
              <span className="switchSlider round"></span>
            </label>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center mt-4">
          {once === "0" ? (
            <div className="d-flex justify-content-between mb-3 days">
              {daysFA.map((day, i) => {
                return (
                  <span
                    className={`fn10 p-1 mx-1 cursor 
                                    ${
                                      dayIndex[i].isActive ? "todayActive" : ""
                                    }`}
                    onClick={() => dayClicked(i)}
                  >
                    {day}
                  </span>
                );
              })}
            </div>
          ) : (
            ""
          )}
          <div className="dateSection d-flex my-2 py-2 px-2 align-items-center date">
            <Col className="text-right">
              <p className="fn m-0">
                <i className="icon-clock px-1"></i> {t("تاریخ")}
              </p>
            </Col>
            <Col>
              {scheduleData && scheduleData.start_date ? (
                <ReactDatePicker
                  onChange={(date) => setStartDate(date)}
                  selected={startDate}
                  timePicker={false}
                  onClickSubmitButton={(val) => submitExample(val)}
                  value={scheduleEnDate}
                  className="customDatePicker"
                />
              ) : (
                <ReactDatePicker
                  onChange={(date) => setStartDate(date)}
                  selected={startDate}
                  timePicker={false}
                  onClickSubmitButton={(val) => submitExample(val)}
                  className="customDatePicker"
                />
              )}
            </Col>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-1">
          <div
            onClick={setScheduleCommand}
            className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center"
          >
            <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
            <small className="fn10 mt-1">{t("تائید")}</small>
          </div>
          <div
            className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center"
            onClick={toggleSchedule}
          >
            <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
            <small className="fn10 mt-1">{t("بازگشت")}</small>
          </div>
        </div>
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const Schedule = withRouter(ScheduleCompp);

export { Schedule };
